package one.healthium.login.ui.silent_login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import one.healthium.domain.user.UserModel
import one.healthium.login.ui.silentLogin.SilentLoginViewModel
import one.healthium.ui.compose.components.AppLoadingScreen
import one.primehealth.analytics.AppAnalytics
import one.primehealth.analytics.events.Events
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

interface SilentLoginEventDelegate {
    fun onUserSignedIn(user: UserModel)
    fun onDeclined()
}

@Composable
fun SilentLoginScreen(
    token: String,
    standalone: Boolean,
    eventDelegate: SilentLoginEventDelegate,
) {
    val viewModel = koinViewModel<SilentLoginViewModel>()
    val state by viewModel.state.collectAsState()
    val appAnalytics = koinInject<AppAnalytics>()

    LaunchedEffect(token) {
        viewModel.setToken(token)
    }

    val user = state.user
    val error = state.error

    LaunchedEffect(user, error) {
        if (user != null) {
            appAnalytics.logEvent(
                Events.UserAutoSignedUp(email = user.profile.email, uid = user.id)
            )
            eventDelegate.onUserSignedIn(user)
        } else if (error != null) {
            eventDelegate.onDeclined()
        }
    }

    AppLoadingScreen(dim = !standalone)
}